import { exec } from '../utils';

const VALIDATE_QUERY = `
  mutation authenticateFromOauth(
    $token: String!
    $userId: Int!
  ) {
    authenticateFromOauth(
      token: $token
      userId: $userId
    ) {
      uuid
      name
      email
    }
  }
`;

const EXCHANGE_QUERY = `
  mutation authenticateFromOauth(
    $token: String!
    $userId: Int!
  ) {
    authenticateFromOauth(
      token: $token
      userId: $userId
    ) {
      oneTimeToken
    }
  }
`;

interface AuthenticateFromOauthArgs {
  token: string;
  userId: number;
}

interface User {
  uuid: string;
  name: string;
  email: string;
}

interface TokenResponse {
  oneTimeToken: string;
}

interface AuthenticateFromOauthResponse {
  authenticateFromOauth: User;
}

interface ExchangeTokenResponse {
  authenticateFromOauth: TokenResponse;
}

/**
 * Validates JWT and returns user info (used during login)
 */
export const authenticateFromOauth = async (
  params: AuthenticateFromOauthArgs
): Promise<User> => {
  const data = await exec<AuthenticateFromOauthArgs, AuthenticateFromOauthResponse>(
    VALIDATE_QUERY,
    {
      variables: params,
    },
  );

  return data.authenticateFromOauth;
};

/**
 * Exchanges JWT for a one-time badge token (used for API calls)
 */
export const exchangeJwtForBadgeToken = async (
  params: AuthenticateFromOauthArgs
): Promise<string> => {
  const data = await exec<AuthenticateFromOauthArgs, ExchangeTokenResponse>(
    EXCHANGE_QUERY,
    {
      variables: params,
    },
  );

  return data.authenticateFromOauth.oneTimeToken;
};
